import axios from 'axios'
export const HTTP = axios.create({
  baseURL: process.env.VUE_APP_BASEURL,
  headers: {
    'Ocp-Apim-Subscription-Key': process.env.VUE_APP_APIM_KEY
  }
})
